var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50008 8.66699L2.16675 5.33366L3.10008 4.36699L4.83341 6.10033V0.666992H6.16675V6.10033L7.90008 4.36699L8.83341 5.33366L5.50008 8.66699ZM1.50008 11.3337C1.13341 11.3337 0.819526 11.2031 0.558415 10.942C0.297304 10.6809 0.166748 10.367 0.166748 10.0003V8.00033H1.50008V10.0003H9.50008V8.00033H10.8334V10.0003C10.8334 10.367 10.7029 10.6809 10.4417 10.942C10.1806 11.2031 9.86675 11.3337 9.50008 11.3337H1.50008Z",
    fill: "#3474E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPrimaryIcon);
export default __webpack_public_path__ + "static/media/download_primary_icon.8c541247387df1d2540274c376a61278.svg";
export { ForwardRef as ReactComponent };